import PdfUploadField from '../../../products/components/pdf-upload-field/pdf-upload-field';
import { getResultingOfferFile, KEEP_OFFER_FILE, OfferFileChange, StoredOfferFile } from '../../lib/offer-file';
import OfferFormSection, { CollapsiblePanelProps } from '../offer-form-section/offer-form-section';

export interface OfferFileSectionProps {
  /** The PDF stored with the draft, `null` if none. */
  stored: StoredOfferFile | null;
  change: OfferFileChange;
  onChange: (change: OfferFileChange) => void;
  panel: CollapsiblePanelProps;
  disabled?: boolean;
}

/** Optional offer PDF – uploaded, replaced or removed when the draft is saved. */
const OfferFileSection = ({ stored, change, onChange, panel, disabled }: OfferFileSectionProps) => (
  <OfferFormSection
    title="Angebots-PDF"
    description="Optional. Geht als Anhang mit der Angebotsmail und der Vertragsbestätigung raus und kann im Checkout heruntergeladen werden."
    panel={panel}>
    <PdfUploadField
      file={getResultingOfferFile(change, stored)}
      // Removing: a stored PDF is deleted on save – without one there is nothing to change.
      onChange={(file) => onChange(file ? { action: 'upload', file } : stored ? { action: 'remove' } : KEEP_OFFER_FILE)}
      disabled={disabled}
    />
  </OfferFormSection>
);

export default OfferFileSection;
